import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import LoginGlobal from "../data/LoginGlobal"
import DoubleUpChallenge from "../snippets/games/DoubleUpChallenge"

export default function DoubleUp() {
  const data = promotionsData.find((promo) => promo.title === "Double Up")
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const { doubleUpTurnover } = useGlobalContext()
  const [isShowDoubleUp, setIsShowDoubleUp] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Double Up Challenge</title>
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      {isShowDoubleUp && <DoubleUpChallenge />}
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>DOUBLE-UP CHALLENGE!</h1>
                <h2>Give it a CALL, place a BET, and do the CHALLENGE!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period : </strong>
                  <span>Month Date, Year - Month Date, Year</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <ol>
                  <li>
                    Players with weekly turnover of at least 100,000 - will be
                    challenged to double their turnover by placing a bet every
                    Monday, from 1pm - 12mn.
                  </li>
                  <li>
                    Maximum bet amount is based on the player's accumulated
                    weekly turnover ranging from PHP 500 - PHP 5,000 (please see
                    the table below for reference).
                  </li>
                  <li>
                    If they successfully complete the challenge before the
                    cutoff (Monday 11:59am), they win the bet and automatically
                    receive x2 of their stake amount (maximum PHP 10,000) - with
                    no rollover requirement.
                  </li>
                  <li>
                    FGH reserves the right to modify, suspend, or terminate this
                    promotion at any time without prior notice.
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <th>Level</th>
                      <th>Minimum Turnover</th>
                      <th>Minimum Bet</th>
                      <th>Maximum Bet</th>
                      <th>Turnover Goal</th>
                    </thead>

                    <tbody>
                      <tr>
                        <td>Beginner</td>
                        <td>100,000</td>
                        <td>500.00</td>
                        <td>500.00</td>
                        <td>200,000</td>
                      </tr>
                      <tr>
                        <td>Pro</td>
                        <td>250,000.00</td>
                        <td>500.00</td>
                        <td>1,250.00</td>
                        <td>500,000.00</td>
                      </tr>
                      <tr>
                        <td>Elite</td>
                        <td>500,000.00</td>
                        <td>500.00</td>
                        <td>2,500.00</td>
                        <td>1,000,000.00</td>
                      </tr>
                      <tr>
                        <td>Legend</td>
                        <td>1,000,000.00</td>
                        <td>500.00</td>
                        <td>5,000.00</td>
                        <td>2,000,000.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h2>Example: </h2>{" "}
                <table className="promotion-tnc-table daily-wins-table">
                  <thead>
                    <th style={{ background: "#111" }} colSpan={2}>
                      Player A
                    </th>
                  </thead>
                  <thead>
                    <th>1st week</th>
                    <th>2nd week</th>
                  </thead>

                  <tbody>
                    <tr>
                      <td>₱1,000,000</td>
                      <td>₱2,000,000.00</td>
                    </tr>
                    <tr>
                      <td>--</td>
                      <td>--</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Stake</b>
                      </td>
                      <td>
                        <b>Payout</b>
                      </td>
                    </tr>
                    <tr>
                      <td>₱5,000.00</td>
                      <td>₱10,000.00</td>
                    </tr>
                  </tbody>
                </table>
                <table className="promotion-tnc-table daily-wins-table">
                  <thead>
                    <th style={{ background: "#111" }} colSpan={2}>
                      Player B
                    </th>
                  </thead>
                  <thead>
                    <th>1st week</th>
                    <th>2nd week</th>
                  </thead>

                  <tbody>
                    <tr>
                      <td>₱100,000.00</td>
                      <td>₱200,000.00</td>
                    </tr>
                    <tr>
                      <td>--</td>
                      <td>--</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Stake</b>
                      </td>
                      <td>
                        <b>Payout</b>
                      </td>
                    </tr>
                    <tr>
                      <td>₱500.00</td>
                      <td>₱1,000.00</td>
                    </tr>
                  </tbody>
                </table>
                <table className="promotion-tnc-table daily-wins-table">
                  <thead>
                    <th style={{ background: "#111" }} colSpan={2}>
                      Player C
                    </th>
                  </thead>
                  <thead>
                    <th>1st week</th>
                    <th>2nd week</th>
                  </thead>

                  <tbody>
                    <tr>
                      <td>₱300,000.00</td>
                      <td>₱600,000.00</td>
                    </tr>
                    <tr>
                      <td>--</td>
                      <td>--</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Stake</b>
                      </td>
                      <td>
                        <b>Payout</b>
                      </td>
                    </tr>
                    <tr>
                      <td>₱1,250.00</td>
                      <td>₱2,500.00</td>
                    </tr>
                  </tbody>
                </table>
                <div className="promotion-tnc-cta">
                  {isLoggedIn ? (
                    doubleUpTurnover >= 100000 ? (
                      <button
                        className="promotion-cta-btn"
                        onClick={() => {
                          setIsShowDoubleUp(false)
                          setTimeout(() => setIsShowDoubleUp(true), 0)
                        }}
                      >
                        Play Now
                      </button>
                    ) : (
                      <a className="promotion-cta-btn" href="/slots">
                        Play Now
                      </a>
                    )
                  ) : (
                    <LoginGlobal
                      label="Play Now"
                      btnClass="promotion-cta-btn"
                      onlyBtn={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
